import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';
import { trackEvent } from '@/lib/analytics';

// Real-user Core Web Vitals, sent through the same GA4 pipe every other
// event already uses -- no new infrastructure, no new dashboard to build.
// This is deliberately the smallest useful version: three metrics, no
// attribution build (which adds debug detail we don't need yet), rounded
// values so GA4 doesn't fragment event params into many near-duplicate
// values. trackEvent is already a no-op if gtag hasn't loaded, so this can
// never block or throw on the pages it's watching.
const report = (metric: Metric) => {
  trackEvent('web_vitals', {
    metric_name: metric.name,
    metric_value: metric.name === 'CLS' ? metric.value : Math.round(metric.value),
    metric_rating: metric.rating,
    page_path: window.location.pathname,
  });
};

export const initWebVitalsReporting = () => {
  onLCP(report);
  onCLS(report);
  onINP(report);
};
